import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.info');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.company.info/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminWidgetCompanyInfoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;

    public businessAreaSuggestions: string[] = [];
    public filteredSuggestions: string[] = [];
    public showSuggestions: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.loadBusinessAreas();
        if (!this.company.extra) this.company.extra = {};
        if (!this.company.extra.contacts) this.company.extra.contacts = [];
    }

    public async loadBusinessAreas() {
        const { code, data } = await wiz.call("load_business_areas");
        if (code === 200) {
            this.businessAreaSuggestions = data.areas || [];
        }
    }

    public onBusinessAreaInput(value: string) {
        if (!value || !value.trim()) {
            this.filteredSuggestions = [];
            this.showSuggestions = false;
            return;
        }
        const lower = value.toLowerCase();
        this.filteredSuggestions = this.businessAreaSuggestions.filter(
            (s) => s.toLowerCase().includes(lower) && s.toLowerCase() !== lower
        );
        this.showSuggestions = this.filteredSuggestions.length > 0;
    }

    public async selectBusinessArea(area: string) {
        this.company.extra.business_area = area;
        this.showSuggestions = false;
        this.filteredSuggestions = [];
        await this.service.render();
    }

    public hideBusinessAreaSuggestions() {
        setTimeout(() => {
            this.showSuggestions = false;
            this.service.render();
        }, 200);
    }

    public async addContact() {
        if (!this.company.extra) this.company.extra = {};
        if (!this.company.extra.contacts) this.company.extra.contacts = [];
        this.company.extra.contacts.push({ name: '', title: '', phone: '', email: '', invited: false });
        await this.service.render();
    }

    public async removeContact(index: number) {
        const ok = await this.alert("담당자를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.company.extra.contacts.splice(index, 1);
        await this.service.render();
    }

    public async inviteContact(index: number) {
        const contact = this.company.extra.contacts[index];
        if (!contact.email || !contact.email.includes('@')) {
            await this.alert("유효한 이메일을 입력해주세요.");
            return;
        }

        const ok = await this.alert(
            `${contact.email}로 초대를 발송하시겠습니까?`,
            "info", "취소", "초대 발송"
        );
        if (!ok) return;

        await this.service.loading.show();
        try {
            const { code, data } = await wiz.call("invite_contact", {
                email: contact.email,
                name: contact.name || '',
                company_name: this.company.company_name || ''
            });

            if (code === 200) {
                contact.invited = true;
                if (data.user_id) contact.user_id = data.user_id;
                if (data.already_exists) {
                    await this.alert("이미 가입된 사용자입니다.", "info");
                } else {
                    await this.alert("초대가 발송되었습니다.", "success");
                }
            } else {
                await this.alert(data?.message || "초대 발송에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("초대 발송 중 오류가 발생했습니다.");
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    public async update() {
        // contacts → 기존 manager/manager_email/manager_phone 동기화
        if (this.company.extra?.contacts?.length > 0) {
            const first = this.company.extra.contacts[0];
            this.company.manager = first.name || '';
            this.company.manager_email = first.email || '';
            this.company.manager_phone = first.phone || '';
        }

        let body = JSON.parse(JSON.stringify(this.company));
        const { code, data } = await wiz.call("update", { info: JSON.stringify(body) });
        if (code == 200) await this.alert("저장되었습니다", "success");
        else if (code == 201) {
            if (this.company.status == 'investment')
                await this.service.href(`/admin/invest/company/${data}/overview`);
            else
                await this.service.href(`/admin/invest/review_company/${data}/overview`);
            location.reload();
            return;
        }
        else await this.alert("사업자 등록번호를 확인해주세요.", "error");
        await this.service.render();
    }

    public async clearValue(obj, key) {
        obj[key] = null;
        await this.service.render();
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        let fd = new FormData();
        fd.append('upload', files[0]);
        let fdurl = '/file/upload';
        const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
        item[target] = url;
        this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public timestamp() {
        return new Date().getTime();
    }

    public activeClass(target: string, status: string) {
        if (target == status) {
            return "group flex gap-x-3 mr-2 rounded-full bg-zinc-600 px-3.5 py-2 text-sm font-semibold text-white hover:bg-zinc-800 ";
        }
        return "group flex gap-x-3 rounded-md mr-2 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    public async loadInfo() {
        if (this.company && this.company.registed_number) {
            const { code, data } = await wiz.call("loadInfo", { registedNumber: this.company.registed_number });

            if (code != 200) return;

            this.company.company_name = data.info.company_name  // 기업명
            this.company.ceo = data.info.extra.ceo  // CEO 명
            this.company.location_short = data.info.extra.location    // 소재지

            this.service.render();
        }
    }

    public ocrLoading: boolean = false;

    public async uploadBusinessCert() {
        let files = await this.service.file.select({ accept: 'image/*,.pdf' });
        if (!files || files.length == 0) return;

        this.ocrLoading = true;
        await this.service.render();

        let fd = new FormData();
        fd.append('file', files[0]);

        try {
            let { code, data } = await wiz.call("ocr_business_registration", fd, {
                processData: false,
                contentType: false
            });

            if (code == 200 && data.result) {
                let r = data.result;
                let extracted = false;
                if (r.company_name) { this.company.company_name = r.company_name; extracted = true; }
                if (r.ceo) { this.company.ceo = r.ceo; extracted = true; }
                if (r.location) {
                    if (!this.company.extra) this.company.extra = {};
                    this.company.extra.location_short = r.location;
                    extracted = true;
                }
                if (r.registed_number) {
                    this.company.registed_number = r.registed_number;
                    extracted = true;
                }
                if (extracted) {
                    let fields = [];
                    if (r.registed_number) fields.push("사업자등록번호");
                    if (r.company_name) fields.push("기업명");
                    if (r.ceo) fields.push("대표자명");
                    if (r.location) fields.push("소재지");
                    await this.alert(`추출 완료: ${fields.join(', ')}`, "success");
                } else {
                    console.log("OCR raw text:", data.raw_text);
                    await this.alert("사업자등록증에서 정보를 추출하지 못했습니다.\n이미지가 선명한지 확인해주세요.");
                }
            } else {
                let msg = (data && data.message) ? data.message : "OCR 처리에 실패했습니다.";
                if (data && data.raw_text) console.log("OCR raw text:", data.raw_text);
                await this.alert(msg);
            }
        } catch (e) {
            console.error("OCR error:", e);
            await this.alert("OCR 처리 중 오류가 발생했습니다.");
        }

        this.ocrLoading = false;
        await this.service.render();
    }

}

export default PortalLpsysadminWidgetCompanyInfoComponent;